import React, { useEffect, useState } from 'react'
import {
  useElements,
  useStripe,
  CardNumberElement,
  CardExpiryElement,
  CardCvcElement,
} from '@stripe/react-stripe-js'
import { useDispatch, useSelector } from 'react-redux'
import styles from './payment.module.scss'
import { useNavigate, useLocation, Link } from 'react-router-dom'
import Logo from '../../../icons/logo-white.svg'
import Cvc from '../../../icons/cvc.svg'
import LogoFlexxi from '../../../icons/miniLogo.svg'
import Loading from '../../../icons/loading.svg'
import Robbot from '../../../icons/robbotik.svg'
import Stripe from '../../../icons/stripe.svg'
import ArrowBack from '../../../icons/arrowBack-white.svg'
import { setChallengeStep } from '../../../redux/actions/challengeStaps'
import {
  completePaymentMethod,
  paymentSetUpIntent,
  paymentSetUpIntentSubscription,
  reActivateSubscription,
} from '../../../api/paymentApi'
import cx from 'classnames'
import {
  setPaymentMethod,
  setReimbursementRef,
} from '../../../redux/actions/payment'
import { getReimbursements } from '../../../api/userApi'
import { setUserEmail } from '../../../redux/actions/authActions'
import { submitReimbursement } from '../../../api/formApi'
import PageComponent from '../PageComponent'
import {
  careReceipients,
  legalRepresentations,
  authorizedPerson,
  representativePerson,
  representationByCommerciallyActive,
  representationByPrivateIndividual,
  quizQuestions,
} from '../../../redux/defaultStates'
import {
  setUpdateAuthorizedPerson,
  setUpdateCareQuizQuestions,
  setUpdateLegalRepresentations,
  setUpdateRepresentationByCommerciallyActive,
  setUpdateRepresentationByPrivateIndividual,
  setUpdateRepresentativePerson,
} from '../../../redux/actions/updateState'
import { updateQuiz } from '../../../redux/actions/quizQuestions'
const Payment = () => {
  const { email } = useSelector((state) => state.userDetails)
  const [clientSecret, setClientSecret] = useState(null)
  const [amount, setAmount] = useState()
  const [name, setName] = useState('')
  const [stripeErrorConfirm, setStripeErrorConfirm] = useState('')
  const [disabledBtn, setDisabledBtn] = useState(false)
  const [windowWidth, setWindowWidth] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  })
  const handleResize = () => {
    setWindowWidth({
      width: window.innerWidth,
      height: window.innerHeight,
    })
  }
  useEffect(() => {
    window.addEventListener('resize', handleResize)

    // Remove event listener on component unmount
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])
  const [errors, setErrors] = useState({
    numberErr: '',
    cvcErr: '',
    expDateErr: '',
    nameErr: '',
    stripeErrorMessage: '',
  })
  const arr = ['numberErr', 'expDateErr', 'cvcErr']
  const [touched, setTouched] = useState({
    numberTouched: false,
    expDateTouched: false,
    cvcTouched: false,
    nameTouched: false,
  })
  const disabled =
    errors.numberErr ||
    errors.nameErr ||
    errors.cvcErr ||
    errors.expDateErr ||
    !touched.numberTouched ||
    !touched.expDateTouched ||
    !touched.cvcTouched ||
    !touched.nameTouched
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const elements = useElements()
  const stripe = useStripe()
  const location = useLocation()
  const from = location.state?.from
  const reimbursementRef = useSelector((state) => state.payment).reimbursementRef
  const CARD_ELEMENT_OPTIONS = {
    showIcon: true,
    hidePostalCode: true,
    style: {
      base: {
        fontSize: '14px',
        lineHeight: '22px',
        fontWeight: '400',
        // fontFamily: '"Open Sans", sans-serif',
        fontSmoothing: 'antialiased',
        iconColor: '#666',
        '::placeholder': {
          color: '#A29DB0',
        },
      },
      invalid: {
        color: '#F14055',
        borderColor: '#F14055',
        ':focus': {
          color: '#F14055',
          borderColor: '#F14055',
        },
      },
    },
  }

  useEffect(() => {
    if (from === '/settings') {
      !clientSecret &&
        paymentSetUpIntentSubscription(false)
          .then((data) => {
            setClientSecret(data.token)
            setAmount(data.amount)
          })
          .catch((err) => console.log(err))
    } else {
      const requestBody = {
        reimbursementRef,
        email,
        option: 2,
      }
      !clientSecret &&
        paymentSetUpIntent(requestBody)
          .then((data) => {
            setClientSecret(data.token)
            setAmount(data.amount)
          })
          .catch((err) => console.log(err))
    }
  }, [])

  const handleBackClick = () => {
    if (from === '/settings') {
      navigate(`${from}`)
    } else {
      navigate('/startChallenge')
      dispatch(setChallengeStep('startChallenge', { challengeStep: 2 }))
      // dispatch(setUserEmail(''))
      // dispatch(updateQuiz({ ...quizQuestions }))
      // dispatch(setUpdateCareQuizQuestions({ ...careReceipients }))
      // dispatch(setUpdateLegalRepresentations({ ...legalRepresentations }))
      // dispatch(setUpdateAuthorizedPerson({ ...authorizedPerson }))
      // dispatch(setUpdateRepresentativePerson({ ...representativePerson }))
      // dispatch(
      //   setUpdateRepresentationByCommerciallyActive({
      //     ...representationByCommerciallyActive,
      //   }),
      // )
      // dispatch(
      //   setUpdateRepresentationByPrivateIndividual({
      //     ...representationByPrivateIndividual,
      //   }),
      // )
    }
  }
  const handleName = (e, field) => {
    const value = e.currentTarget.value
    setTouched({
      ...touched,
      [field + 'Touched']: value?.trim() ? true : false,
    })
    setName(value)
    // !value?.trim()
    //   ? setErrors({ ...errors, [field + 'Err']: 'Pflichtfeld' })
    //   : setErrors({ ...errors, [field + 'Err']: '' })
  }
  const handleConfirm = async (e) => {
    e.preventDefault()
    if (
      errors.cvcErr === '' &&
      errors.numberErr === '' &&
      errors.expDateErr === ''
    ) {
      setDisabledBtn(true)
    }

    try {
      // Call confirmCardSetup
      const { setupIntent, error } = await stripe.confirmCardSetup(clientSecret, {
        payment_method: {
          card: elements.getElement(CardNumberElement),
          billing_details: {
            name: name,
            email: email,
          },
        },
      })

      // Check for errors
      if (error) {
        // Handle specific errors like card_declined
        setDisabledBtn(false) // Re-enable button on error
        setStripeErrorConfirm('Die Zahlungsmethode konnte nicht verifiziert werden.')
        // if (error.code === 'card_declined') {
        //   console.error('Card declined:', error.message, error.decline_code)
        //   // Display user-friendly error message
        //   alert(
        //     `Card declined: ${error.message} (${error.decline_code || 'No specific reason provided'})`,
        //   )
        // } else {
        //   console.error('Setup error:', error.message)
        //   alert(`Error: ${error.message}`)
        // }
        // setDisabledBtn(false) // Re-enable button on error
        // return // Stop further execution
      }

      // Success case: setupIntent is available
      dispatch(setPaymentMethod(setupIntent.payment_method))

      if (from === '/settings') {
        const body = { paymentMethodId: setupIntent.payment_method }
        if (setupIntent.payment_method) {
          try {
            await reActivateSubscription(body)
            navigate('/settings')
          } catch (err) {
            console.error('Re-activate subscription error:', err)
            // alert('Failed to re-activate subscription. Please try again.')
          }
        }
      } else {
        const requestBody = {
          reimbursementRef: reimbursementRef,
          paymentMethodId: setupIntent.payment_method,
        }
        if (setupIntent.payment_method) {
          try {
            await completePaymentMethod(requestBody)
            const data = await getReimbursements(reimbursementRef)
            dispatch(setUserEmail(data.email))
            dispatch(setReimbursementRef(data.ref))
            // dispatch(setChooseCard(data.option));
            const submitRequestBody = {
              ref: data.ref,
              email: data.email,
              option: 2,
            }
            await submitReimbursement(submitRequestBody)
            navigate('/set-password')
          } catch (err) {
            console.error('Payment or reimbursement error:', err)
            // alert('Failed to complete payment or reimbursement. Please try again.')
          }
        }
      }
    } catch (err) {
      // Catch any unexpected errors from confirmCardSetup
      console.error('Unexpected error:', err)
      // alert('An unexpected error occurred. Please try again.')
    } finally {
      setDisabledBtn(false) // Ensure button is re-enabled
    }
  }
  const handleChangeStripeElement = (e, field) => {
    setStripeErrorConfirm('')
    setTouched({ ...touched, [field + 'Touched']: e?.complete ? true : false })
    e?.error?.message
      ? setErrors({
          ...errors,
          [field + 'Err']: e?.error?.message,
          stripeErrorMessage: e?.error?.message,
        })
      : setErrors({
          ...errors,
          [field + 'Err']: '',
          stripeErrorMessage:
            errors[arr.filter((err) => err !== field + 'Err')[0]] ||
            errors[arr.filter((err) => err !== field + 'Err')[1]] ||
            '',
        })
  }
  const paymentAmount = amount?.toFixed(2).replace('.', ',')
  return (
    <PageComponent>
      <div className={styles.payment}>
        <div>
          <div>
            {windowWidth.width > 980 && (
              <div className={styles.backSection}>
                <img src={ArrowBack} alt="ArrowBack" onClick={handleBackClick} />
                <img src={Logo} alt="Logo" />
              </div>
            )}
            <div className={styles.amountSection}>
              <div className={styles.amountInfo}>
                <div>
                  <img src={LogoFlexxi} alt={'Logo'} />
                  <span>FLEXXI Care Deutschland GmbH</span>
                </div>
                <p>FLEXXI Care Smart</p>
                <p>
                  {`€ ${paymentAmount}`}
                  <sup>pro Jahr</sup>{' '}
                </p>
                <div>
                  <span>FLEXXI Care Smart Plan Bezahlung abonnieren</span>
                  <span>€{paymentAmount}</span>
                </div>
                <div>
                  <span>Gesamtbetrag</span>
                  <span>€{paymentAmount}</span>
                </div>
              </div>
              {/*<img src={Robbot} alt={'Robbot'} />*/}
            </div>
          </div>
          <div>
            <div className={styles.form}>
              <h2>Mit Karte zahlen</h2>
              <div>
                <label>
                  <span>E-Mail</span>
                  <input type={'text'} value={email} disabled={true} />
                </label>
              </div>
              <div>
                <label>
                  <span>Kartendaten</span>
                  <div
                    className={cx(styles.cardElementWrapper, {
                      [styles.invalidElementWrapper]: errors.numberErr,
                    })}
                  >
                    <CardNumberElement
                      options={CARD_ELEMENT_OPTIONS}
                      className={cx(styles.cardElement, {
                        [styles.invalidElement]: errors.numberErr,
                      })}
                      onChange={(e) => handleChangeStripeElement(e, 'number')}
                    />
                  </div>

                  <div>
                    <div
                      className={cx(styles.expiryWrapper, {
                        [styles.invalidElementWrapper]: errors.expDateErr,
                      })}
                    >
                      <CardExpiryElement
                        options={CARD_ELEMENT_OPTIONS}
                        className={cx(styles.expiredElement, {
                          [styles.invalidElement]: errors.expDateErr,
                        })}
                        onChange={(e) => handleChangeStripeElement(e, 'expDate')}
                      />
                    </div>
                    <div
                      className={cx(styles.cvcWrapper, {
                        [styles.invalidElementWrapper]: errors.cvcErr,
                      })}
                    >
                      <img src={Cvc} alt="CVC" />
                      <CardCvcElement
                        options={CARD_ELEMENT_OPTIONS}
                        className={cx(styles.cvcElement, {
                          [styles.invalidElement]: errors.cvcErr,
                        })}
                        onChange={(e) => handleChangeStripeElement(e, 'cvc')}
                      />
                    </div>
                  </div>
                  {errors.stripeErrorMessage && (
                    <span className={cx(styles.errorMessage)}>
                      {errors.stripeErrorMessage}
                    </span>
                  )}
                </label>
              </div>
              <div>
                <label>
                  <span>Name des/der Karteninhaber/in</span>
                  <input
                    type={'text'}
                    value={name}
                    onChange={(e) => handleName(e, 'name')}
                    placeholder={'Vollständiger Name'}
                    className={cx({
                      [styles.invalidElement]: errors.nameErr,
                    })}
                  />
                  {/*{errors.nameErr && touched.nameTouched && (*/}
                  {/*  <span className={cx(styles.errorMessage)}>{errors.nameErr}</span>*/}
                  {/*)}*/}
                </label>
              </div>
              <button
                className={cx(styles.button, {
                  [styles.disabled]: !!disabledBtn,
                })}
                disabled={!!disabledBtn}
                onClick={handleConfirm}
              >
                Zahlungspflichtig abonnieren
                {!!disabledBtn && <img src={Loading} alt={Loading} />}
              </button>
              {stripeErrorConfirm !== '' && (
                <span className={cx(styles.errorMessageForStrip)}>
                  {stripeErrorConfirm}
                </span>
              )}
              <div className={styles.stripe}>
                <Link to={'https://stripe.com/'} target={'_blank'}>
                  <span>Powered by</span>
                  <img src={Stripe} alt={'Stripe'} />
                </Link>
                <span>
                  <Link to={'https://stripe.com/legal/consumer'} target={'_blank'}>
                    Bedingungen
                  </Link>
                </span>
                <span>
                  <Link to={'https://stripe.com/privacy'} target={'_blank'}>
                    Datenschutz
                  </Link>
                </span>
              </div>
              <span>
                Indem Sie Ihr Abonnement bestätigen, gestatten Sie FLEXXI Care
                Deutschland GmbH, zukünftige Zahlungen Ihrem Zahlungsinstrument gemäß
                den allgemeinen Geschäftsbedingungen zu belasten. Sie können Ihr
                Abonnement jederzeit kündigen.
              </span>
            </div>
          </div>
        </div>
      </div>
    </PageComponent>
  )
}

export default Payment
